import { useTicketPriorities } from "@jugl-web/domain-resources/tickets/hooks/useTicketPriorities";
import { TicketPriority } from "@jugl-web/rest-api/tickets/models/common-types";
import { TicketPriorityPickerPopover } from "@web-src/modules/client-support/components/TicketPriorityPickerPopover";
import { TicketPropertyPill } from "@jugl-web/domain-resources/tickets/components/TicketPropertyPill";
import { FC, useMemo } from "react";
import {
  TicketDetailItem,
  TicketDetailItemPlaceholder,
} from "../TicketDetailItem";

interface PriorityDetailItemProps {
  priority: TicketPriority;
  onChange: (priority: TicketPriority) => void;
}

export const PriorityDetailItem: FC<PriorityDetailItemProps> = ({
  priority,
  onChange,
}) => {
  const { getPriorityById } = useTicketPriorities();

  const priorityDetails = useMemo(
    () => getPriorityById(priority),
    [priority, getPriorityById]
  );

  return (
    <TicketPriorityPickerPopover
      priority={priority}
      onChange={onChange}
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={TicketDetailItem}
          ref={triggerRef}
          isInteractive
          isActive={isOpen}
          label="Priority"
          content={
            priority !== "none" ? (
              <TicketPropertyPill
                icon={priorityDetails.icon}
                label={priorityDetails.label}
              />
            ) : (
              <TicketDetailItemPlaceholder />
            )
          }
        />
      )}
    />
  );
};
